import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';

@observer
export default class FormLabel extends React.Component {

  static propTypes = {
    htmlFor: PropTypes.string,
    labelText: PropTypes.string.isRequired,
    additionalSrText: PropTypes.string,
    helperText: PropTypes.string,
    hasError: PropTypes.bool,
    errorMessage: PropTypes.string,
    charLimitReached: PropTypes.bool,
    fieldIsRequired: PropTypes.bool,
    srOnly: PropTypes.bool,
    announceError: PropTypes.bool
  }

  static defaultProps = {
    htmlFor: '',
    additionalSrText: '',
    helperText: '',
    hasError: false,
    errorMessage: 'This field has an error.',
    fieldIsRequired: false
  }

  renderFieldError() {
    /* Screen reader section should always be present, not conditionally
    rendered, to allow aria to manage changes appropriately. */
    return (
      <div id={this.props.htmlFor + 'Error'} className="msgBlock error error-list">
        <span role="alert" aria-atomic="true">
          {this.props.charLimitReached ? 'Character limit reached.' : ''}
        </span>
        <span role={this.props.announceError ? 'status' : ''} aria-live={this.props.announceError ? 'polite' : ''} aria-atomic="true">
          {this.props.hasError ? this.props.errorMessage : ''}
        </span>
      </div>
    );
  }

  render() {
    const TagName = this.props.htmlFor ? 'label' : 'legend';
    return (
      <div className="form-label">
        <TagName className={`col-form-label ${this.props.srOnly ? 'sr-only' : ''}`} htmlFor={this.props.htmlFor}>
          {this.props.labelText}
          {this.props.additionalSrText ? <span className="sr-only">{this.props.additionalSrText}</span> : ''}
          {this.props.fieldIsRequired ? <span className="required-asterisks"> *</span> : ''}
          <span className="sr-only">.{/*Provide a sentence break for screen reader*/}</span>
          {this.props.helperText ? <div className="help-text">{this.props.helperText}</div> : ''}
          {this.renderFieldError()}
        </TagName>
      </div>
    )
  }
}
